module.exports = __webpack_public_path__ + "static/media/9DESA22.04a105bb.jpg";